/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PaymentDetailsViewModel } from './PaymentDetailsViewModel';
import {
    PaymentDetailsViewModelFromJSON,
    PaymentDetailsViewModelFromJSONTyped,
    PaymentDetailsViewModelToJSON,
} from './PaymentDetailsViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfPaymentDetailsViewModel
 */
export interface ResultOfPaymentDetailsViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfPaymentDetailsViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfPaymentDetailsViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfPaymentDetailsViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfPaymentDetailsViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfPaymentDetailsViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfPaymentDetailsViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfPaymentDetailsViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {PaymentDetailsViewModel}
     * @memberof ResultOfPaymentDetailsViewModel
     */
    data?: PaymentDetailsViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfPaymentDetailsViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfPaymentDetailsViewModel interface.
 */
export function instanceOfResultOfPaymentDetailsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfPaymentDetailsViewModelFromJSON(json: any): ResultOfPaymentDetailsViewModel {
    return ResultOfPaymentDetailsViewModelFromJSONTyped(json, false);
}

export function ResultOfPaymentDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfPaymentDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : PaymentDetailsViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfPaymentDetailsViewModelToJSON(value?: ResultOfPaymentDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': PaymentDetailsViewModelToJSON(value.data),
        'Count': value.count,
    };
}

